var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.74 277.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-6);}.cls-5{fill:url(#linear-gradient-11);}.cls-6{fill:url(#linear-gradient-10);}.cls-7{fill:#343652;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-7);}.cls-3{font-family:Mont-HeavyDEMO, Mont;font-size:71.68px;letter-spacing:.04em;}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 99.08,
    y1: 68.66,
    x2: 99.08,
    y2: 224.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 142.03,
    y1: 68.66,
    x2: 142.03,
    y2: 224.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 36.42,
    y1: 259.97,
    x2: 102.17,
    y2: 183.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cf2f",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9cf2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 194.31,
    y1: 101.37,
    x2: 65.72,
    y2: 202.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bb95",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41bb95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0,
    y1: 171.19,
    x2: 43.64,
    y2: 171.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a26",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 105.87,
    cy: 171.19,
    r: 105.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(80.44 190.42) scale(1.09 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 105.87,
    cy: 171.19,
    r: 90.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.7,188.51v18.53h-63.23v-4.76c34.21-37.07,38.92-43.06,38.92-49.77,0-4.24-3.04-7.08-7.39-7.08-4.77,0-7.68,2.96-7.68,7.66v1.51h-22.47v-1.45c0-15.8,11.27-26.24,29.88-26.24s30.49,10.19,30.49,24.86c0,9.83-3.96,17.38-22.14,36.73h23.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.02,186.74c2.38,0,4.09,1.91,4.09,4.59v3.6h-8.16v-3.6c0-2.69,1.69-4.59,4.07-4.59Zm0,2.51c-1.21,0-2.01,.88-2.01,2.19v1.02h4.04v-1.02c0-1.32-.82-2.19-2.03-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144.16,179.17h1.95v5.8h-8.16v-5.69h1.94v3.25h1.2v-2.92h1.84v2.92h1.22v-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M139.98,174.78h1.3v-2.86h1.97v2.86h2.86v2.47h-8.16v-5.66h2.03v3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.95,169.79v-2.48h8.16v2.48h-8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.95,157.14h8.16v2.03l-4.43,3.53h4.43v2.37h-8.16v-2.14l4.28-3.42h-4.28v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M144.16,149.12h1.95v5.8h-8.16v-5.69h1.94v3.25h1.2v-2.92h1.84v2.92h1.22v-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M142.02,139.02c2.38,0,4.09,1.91,4.09,4.59v3.6h-8.16v-3.6c0-2.69,1.69-4.59,4.07-4.59Zm0,2.51c-1.21,0-2.01,.88-2.01,2.19v1.02h4.04v-1.02c0-1.32-.82-2.19-2.03-2.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.1,230.38c-6.06,1.97-12.52,3.04-19.23,3.04s-13.17-1.08-19.23-3.04c-6.28-2.04-12.12-5.05-17.34-8.85-5.28-3.84-9.92-8.49-13.77-13.77-3.8-5.23-6.81-11.06-8.85-17.34-1.97-6.06-3.04-12.52-3.04-19.23H0C0,182.62,1.83,193.6,5.18,203.91c3.47,10.68,8.59,20.61,15.06,29.5,6.53,8.98,14.44,16.88,23.42,23.42,8.89,6.47,18.82,11.59,29.5,15.06,10.31,3.35,21.3,5.18,32.72,5.18s22.41-1.83,32.72-5.18l-13.49-41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.56,138.48c-3.47-10.68-8.59-20.61-15.06-29.5-6.53-8.98-14.44-16.88-23.42-23.42-8.89-6.47-18.82-11.59-29.5-15.06-10.31-3.35-21.3-5.18-32.72-5.18s-22.41,1.83-32.72,5.18c-10.68,3.47-20.61,8.59-29.5,15.06-8.98,6.53-16.88,14.44-23.42,23.42-6.47,8.89-11.59,18.82-15.06,29.5C1.83,148.78,0,159.77,0,171.19H43.64c0-6.71,1.08-13.17,3.04-19.23,2.04-6.28,5.05-12.12,8.85-17.34,3.84-5.28,8.49-9.92,13.77-13.77,5.23-3.8,11.06-6.81,17.34-8.85,6.06-1.97,12.52-3.04,19.23-3.04s13.17,1.08,19.23,3.04c6.28,2.04,12.12,5.05,17.34,8.85,5.28,3.84,9.92,8.49,13.77,13.77,3.8,5.23,6.81,11.06,8.85,17.34,1.97,6.06,3.04,12.52,3.04,19.23s-1.08,13.17-3.04,19.23c-2.04,6.28-5.05,12.12-8.85,17.34-3.84,5.28-8.49,9.92-13.77,13.77-5.23,3.8-11.06,6.81-17.34,8.85l13.49,41.5c10.68-3.47,20.61-8.59,29.5-15.06,8.98-6.53,16.88-14.44,23.42-23.42,6.47-8.89,11.59-18.82,15.06-29.5,3.35-10.31,5.18-21.3,5.18-32.72s-1.83-22.41-5.18-32.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 170.14,
    width: 43.64,
    height: 2.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.59,36.93h14.51v8.55H21.51V0h11.08V36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.2,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.58,0l-16.13,45.49h-13.87L81.44,0h11.79l11.27,34.34L115.85,0h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.96,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.72,36.93h14.51v8.55h-25.59V0h11.08V36.93Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl2);
export default __webpack_public_path__ + "static/media/lvl2.cd615c370579d857e0d9999aa839e159.svg";
export { ForwardRef as ReactComponent };